import $ from 'jquery';
const SiteMegamenu = {
    init: () => {
        const $siteHeader = $('.site-header');
        if ($siteHeader === null)
            return;
        SiteMegamenu.initActive($siteHeader);
        SiteMegamenu.initInteract($siteHeader);
    },
    initActive: ($siteHeader) => {
        const { origin, pathname, hash } = window.location;
        $siteHeader.find('.megamenu-badge a').each((index, link) => {
            const linkHref = $(link).attr('href');
            // replace 1 : repalce origin
            // replace 2 : replace hash
            // replace 3 : replace last string if it is slash
            const linkPathname = linkHref.replace(origin, '').replace(`${hash}`, '').replace(/\/+$/, '');
            const linkHash = (linkHref.includes('#')) ? linkHref.replace(origin, '').split('#')[1] : '';
            if (linkPathname === pathname && linkHash && hash) {
                $(link).parents('li').addClass('is-selected').addClass('is-exact');
            }
        });
        $siteHeader.find('.megamenu-item .submenu a').each((index, link) => {
            const linkHref = $(link).attr('href');
            const linkPathname = linkHref.replace(origin, '');
            if (linkPathname === pathname) {
                $(link).parents('li').addClass('is-child-active');
                $(link).parents('li').addClass('is-selected');
                $(link).parents('.submenu').css({ display: 'block' });
            }
        });
    },
    initInteract: ($siteHeader) => {
        $siteHeader.find('.megamenu-categories .megamenu-badge a').on('click', (event) => {
            const anchorTarget = event.currentTarget;
            const [, hash] = $(anchorTarget).attr('href').split('#');
            const { pathname } = window.location;
            const pathnameArr = pathname.split('/');
            // if the user is in the products page
            if (hash && pathnameArr[2] === 'products') {
                const $bsTarget = document.querySelector(`[data-bs-target="#${hash}"]`);
                if ($bsTarget) {
                    event.preventDefault();
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 0);
                    $bsTarget.click();
                }
            }
        });
        $siteHeader.find('.navbar-collapse .nav-item a').on('mouseenter', (event) => {
            $('.navbar-collapse .nav-item').removeClass('is-current');
            $('.megamenu-item').removeClass('is-active');
            $('.site-megamenu').css({ height: '' });
        });
        $siteHeader.find('[data-megamenu]').on('mouseenter', (event) => {
            const { megamenu } = event.currentTarget.dataset;
            $(event.currentTarget).parents('.nav-item').addClass('is-current');
            $(megamenu).addClass('is-active');
            // update height
            const megamenuHeight = $(megamenu).outerHeight(true);
            const activeMenuHeight = $(megamenu).find('.is-child-active').parents('.submenu').outerHeight(true) ?? 0;
            $('.site-megamenu').height(megamenuHeight + activeMenuHeight);
        });
        $siteHeader.find('.megamenu-categories').on('mouseleave', (event) => {
            $(event.currentTarget).find('>li').removeClass('is-active').removeClass('is-unhover');
            $(event.currentTarget).find('>li.is-child-active').addClass('is-active');
            $('.submenu').css({ display: '' });
            $('.megamenu-item').removeClass('is-active');
            $('.site-megamenu').css({ height: '' });
        });
        $siteHeader.find('.megamenu-badge').on('mouseenter', (event) => {
            const $parentLi = $(event.currentTarget).parents('li');
            $('.megamenu-categories > li').removeClass('is-active');
            $('.submenu').css({ display: '' });
            $parentLi.siblings('li').addClass('is-unhover');
            $parentLi.removeClass('is-unhover').addClass('is-active');
            $(event.currentTarget).siblings('.submenu').css({ display: 'block ' });
            // update height
            const megamenuCatHeight = $(event.currentTarget).parents('.megamenu-categories').outerHeight(true);
            const submenuHeight = $(event.currentTarget).siblings('.submenu').outerHeight(true) ?? 0;
            $('.site-megamenu').height(megamenuCatHeight + submenuHeight + 1);
        });
    },
};
export default SiteMegamenu;
